import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css'
import { FaLinkedinIn, FaTwitter, FaFacebook } from 'react-icons/fa';

const Navbar = () => {

    return (
        <nav class="navbar navbar-expand-lg  navbar-dark nav_container sticky-top bg-body-tertiary ">
            <div class="container">
                <Link class="navbar-brand" to='/'>Nasim Reza</Link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                    <ul class="navbar-nav mb-2 mb-lg-0">
                        <li class="nav-item">
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                Home
                            </NavLink>
                        </li>
                        <li class="nav-item">
                            <NavLink
                                to="/service"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                Service
                            </NavLink>
                        </li>
                        <li class="nav-item">
                            <NavLink
                                to="/portfolio"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                Portfolio
                            </NavLink>
                        </li>
                        <li class="nav-item">
                            <NavLink
                                to="/blog"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                Blog
                            </NavLink>
                        </li>
                        <li class="nav-item">
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                About
                            </NavLink>
                        </li>
                        <li class="nav-item">
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? 'activeLink' : undefined}`
                                }
                            >
                                Contact
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className='d-flex gap-3 fs-3'>
                    <Link to='https://www.linkedin.com/in/md-nasim-reza-149ab3164/' target='_blank'><FaLinkedinIn className='social-icon' /></Link>
                    <Link to='https://twitter.com/nasimitjes' target='_blank'><FaTwitter className='social-icon' /></Link>
                    <Link to='https://www.facebook.com/nasim.reza.589/' target='_blank'><FaFacebook className='social-icon' /></Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;